import type { FiscalComprobanteExportItem } from './fiscalComprobanteFormat';
import { withFiscalTipLine } from '../domain/fiscalTipLine';

export { FISCAL_TIP_LINE_LABEL, withFiscalTipLine } from '../domain/fiscalTipLine';
export type { FiscalLineWithQtyPrice } from '../domain/fiscalTipLine';

export function mapSaleItemsToFiscalExport(
  items: Array<{
    label?: string | null;
    productId?: string;
    quantity: number;
    price: number;
    sku?: string | null;
    unitOfMeasure?: string | null;
  }>,
  tipAmount: number
): FiscalComprobanteExportItem[] {
  return withFiscalTipLine(
    items.map((it) => ({
      label: it.label ?? it.productId ?? 'Ítem',
      quantity: it.quantity,
      price: it.price,
      sku: it.sku,
      unitOfMeasure: it.unitOfMeasure,
    })),
    tipAmount
  );
}
